const maxNrOfDecimalRegex = (limit: number): RegExp => {
    let limit_str = '1';
    for (let i = 2; i <= limit; i++) {
        limit_str += `,${i}`;
    }
    const str = `^((\\d|[1-9]\\d+)([.,]\\d{${limit_str}})?|[.,]\\d{${
        limit_str
    }})$`;
    return new RegExp(str);
};

// TODO: Turn simple regex functions into consts
const noDecimalRegex = (): RegExp => /^[0-9]\d*$/;

const timeRegex = (): RegExp => /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/;

const validCharactersPattern = (): RegExp =>
    /^[a-zA-Z0-9 éÉæøåÆØÅäöüÄÖÜß\-_()/.,:%+\n]*$/;

const validCharactersRegex = (): RegExp =>
    RegExp('^[a-zA-Z0-9 éÉæøåÆØÅäöüÄÖÜß\\-_()/.,:%+\\n]*$');

const numbersAndLettersRegex = (): RegExp => RegExp('^[a-zA-Z0-9æøåÆØÅ]*$');

const isValidEmail = (email: string): boolean =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const LINEBREAK_REGEX = /\r?\n/;

// Prevent leading zeros like 00, while allowing floats less than 1
const REMOVE_LEADING_ZEROES_REGEX = /^0+(\d)/;

export {
    noDecimalRegex,
    maxNrOfDecimalRegex,
    timeRegex,
    validCharactersRegex,
    validCharactersPattern,
    numbersAndLettersRegex,
    isValidEmail,
    LINEBREAK_REGEX,
    REMOVE_LEADING_ZEROES_REGEX,
};
